/**
 * The state, said plainly (Redesign; the switch moved to the header in D9).
 *
 * THIS REPLACES THE "Status" FIELD, it does not join it. A5b put the switch
 * beside the pill inside a two-column field list, which was the smallest change
 * that could work: the pill said "Aus", the switch sat next to it, and both
 * were the size of a date. But on/off is not one of five equal facts about an
 * automation — it is the only one a reader can CHANGE from this screen, and the
 * only one whose value decides whether the other four matter at all. So it gets
 * its own card at the top, and "Kategorie", "Auslöser" and the rest stay in the
 * grid below as what they are: reference.
 *
 * ONE STATEMENT, NOT A STATEMENT AND A PILL. Rendering the pill in here too
 * would put "Aus" and "Automatisierung ausgeschaltet" side by side, which is
 * the same fact twice and two things to keep in step. The list row keeps the
 * pill — it needs a word, not a sentence — and both read
 * `automationStatusPresentation`, so there is still exactly one rule.
 *
 * A SWITCHED-ON AUTOMATION IS BLUE, NOT GREEN. Green on this page means one
 * thing — "this went well" — and it belongs to run outcomes: the Erfolgreich
 * count, a succeeded run. Being switched on is not a success, it is a state,
 * and it is the state that makes this whole card interactive. So the card takes
 * the brand tone, the same blue as the selected row, the chosen tab and the
 * switch sitting in it. The list's pill stays green, and that is not a drift:
 * a badge the size of a word carries a status colour cheaply, while a
 * full-width green surface would quietly restate "active" as "successful".
 *
 * OFF AND MANUAL STAY QUIET. Neutral for a switched-off automation, muted for
 * one that has no switch at all. Neither is a problem to be flagged, and a
 * page where every state shouts has no way left to say something is wrong.
 *
 * FOR A TYPE WITH NO ON/OFF THE CARD STILL RENDERS. `requirement_reminder`
 * has a real answer to "what is this doing" — it waits to be started by hand —
 * and that answer belongs on screen.
 *
 * THE SWITCH MOVED OUT OF THIS CARD IN D9, into the workspace header. The card
 * lives in the Allgemein tab, and a switch inside a tab is a switch that
 * disappears the moment the reader opens Ausführungen or Protokoll — the one
 * control on the page should not depend on which tab is open. The card keeps
 * the sentence; the header keeps the control and its word. There is still
 * exactly one switch on the page.
 */
import React from "react";

import { automationStatusStatement } from "./AutomationStatusPill";
import { AutomationIconTile, STATUS_ICONS } from "./automationIcons";
import { automationToneClass } from "./automationLabels";

export default function AutomationStatusCard({ automation }) {
  if (!automation) return null;

  const { headline, description, iconKey, tone } =
    automationStatusStatement(automation);

  return (
    <div
      className={`flex items-center gap-3 rounded-[12px] border px-3.5 py-3 ${automationToneClass(
        tone
      )}`}
    >
      <AutomationIconTile icon={STATUS_ICONS[iconKey]} tone={tone} size="md" />

      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <p className="m-0 text-[13px] font-semibold">{headline}</p>
        {/* Inherits the tone's text colour at reduced strength rather than
            taking `text-muted-foreground`: a fixed grey sits wrong on a tinted
            card in one theme or the other, and there are three tints here. */}
        <p className="m-0 text-[11.5px] opacity-80">{description}</p>
      </div>
    </div>
  );
}
